import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// SPA navigation keeps the previous scroll position; reset to the top whenever the
// route changes so every screen opens at its beginning.
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // The page body rarely scrolls — the real scroller is the .main-content pane
    // beside the fixed sidebar. Reset both.
    window.scrollTo(0, 0);
    document.querySelector(".main-content")?.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default ScrollToTop;
